module.exports = __webpack_public_path__ + "static/media/sauce-tartare-healthy.4a758757.jpg";